import { findFirstInteractiveElement } from "../find-first-interactive-element/FindFirstInteractiveElement.function";

export const focusFirstInteractiveElement = (element: HTMLElement | null, fallback?: HTMLElement | null): void => {
    if (element === null) {
        return;
    }

    const firstFocusableElement = findFirstInteractiveElement(element);
    return firstFocusableElement !== null ? firstFocusableElement.focus() : fallback?.focus();
};
